if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Limite de quantité imposée par la marque, 0 = pas de limite.
      // La table fournisseur -> limite est définie dans snippets/quantity-limit.liquid
      // et exposée au JS depuis layout/theme.liquid.
      get quantityLimit() {
        const vendor = (this.dataset.limitProductVendor || '').trim().toLowerCase();
        if (!vendor) return 0;
        return (window.quantityLimitVendors || {})[vendor] || 0;
      }

      // La limite porte sur le produit entier : on additionne toutes les lignes
      // du panier qui portent le même product_id, quelle que soit la déclinaison.
      async exceedsQuantityLimit(requestedQuantity) {
        const limit = this.quantityLimit;
        const productId = parseInt(this.dataset.limitProductId, 10);
        if (!limit || !productId) return false;

        let quantityInCart = 0;
        try {
          const response = await fetch(`${window.routes.cart_url}.js`, {
            headers: { Accept: 'application/json' },
          });
          const cart = await response.json();
          quantityInCart = (cart.items || [])
            .filter((item) => item.product_id === productId)
            .reduce((total, item) => total + item.quantity, 0);
        } catch (e) {
          // Panier illisible (réseau, etc.) : on ne bloque pas la vente.
          return false;
        }

        return quantityInCart + requestedQuantity > limit;
      }

      showQuantityLimitMessage() {
        const message = ((window.quantityLimitStrings || {}).limitReached || '').replace(
          '[limit]',
          this.quantityLimit
        );

        if (!this.hideErrors && this.querySelector('.product-form__error-message-wrapper')) {
          this.handleErrorMessage(message);
          return;
        }

        // Pas d'emplacement d'erreur dans ce formulaire (ajout rapide depuis une
        // carte produit) : on insère un message temporaire.
        let notice = this.querySelector('.quantity-limit-notice');
        if (!notice) {
          notice = document.createElement('p');
          notice.className = 'quantity-limit-notice';
          notice.setAttribute('role', 'alert');
          this.appendChild(notice);
        }
        notice.textContent = message;
        clearTimeout(this.quantityLimitTimeout);
        this.quantityLimitTimeout = setTimeout(() => notice.remove(), 5000);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const requestedQuantity = parseInt(new FormData(this.form).get('quantity'), 10) || 1;
        if (await this.exceedsQuantityLimit(requestedQuantity)) {
          this.showQuantityLimitMessage();
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
